import { subscriberStatusAPI } from './api';

async function subscriberStatus () {
    const env = this.env;
    const appStore = this.env.appStore;
    const apiKey = appStore.widgetSettings.apikey;
    const res = await subscriberStatusAPI({
        apiKey,
        body: {},
        subscriberId: appStore.subscriberId,
        traceId: env.traceId,
        store: this,
    });
    return res;
}

export default subscriberStatus;